import React, { Component } from 'react';
// components
import { SaveButton } from 'components/buttons';
import { BaseSelect } from 'components/inputs';
import {
  Modal, ModalHeader, ModalBody, ModalFooter,
  Row, Col, Input, FormGroup, Label
} from 'reactstrap';
// rows
import { PlatoonRow } from './tabs/PlatoonRow';
import { SettingsRow } from './tabs/SettingsRow';
// functions
import { toast } from 'react-toastify';
import { isAdmin } from 'functions/login';
import { onInputChange, onSelectChange, onCheckboxChange, onJSONChange } from 'functions/events';


const initialState = {
  platoon: {
    class_grade: '', class_sub: '', class_teacher: '',
    email: '', cell: '', miles_balance: 1000,
    miles_per_soldier: 100, pic_mission_type: 0, allow_parent_tasks: 0,
    print_parent_tasks: 0, class_gender: null, whatsapp: 1, updated: 1
  },
  counselor1: '',
  counselor2: '',
  saving: false,
}

class NewPlatoonModal extends Component {

  state = { ...initialState }
  
  onUpdate = updates =>
    this.setState({ platoon: { ...this.state.platoon, ...updates }});

  onChange = onInputChange( this.onUpdate );
  onSelectChange = onSelectChange( this.onUpdate );

  onJSONChange = onJSONChange( this.onUpdate );
  onCheckChange = onCheckboxChange( this.onUpdate );


  submit = e => {
    e.preventDefault();
    const isCamp = this.props.login.inst_id === 8;
    if ( !this.state.platoon.class_grade )
      return toast.error( isCamp ? 'Cannot create Bunk without a bunk number.' : 'Cannot create Platoon without grade.' );

    this.setState({ saving: true });

    const { counselor1, counselor2 } = this.state;
    const platoon = isCamp
      ? { ...this.state.platoon, class_teacher: [counselor1, counselor2].filter(Boolean).join('; ') }
      : this.state.platoon;

    this.props.onSubmit( platoon )
    .then( platoon => { 
      this.props.refresh();
      this.toggle();
    })
    .catch( e => toast.error( e.message ) );
  }

  toggle = () => {
    this.props.toggle();
    this.setState({ ...initialState });
  }

  render(){
    const { isOpen, login } = this.props;
    const { platoon, saving, counselor1, counselor2 } = this.state;
    const isCamp = login.inst_id === 8;

    const inputProps = { onChange: this.onChange, required: !isCamp };
    const checkProps = { onChange: this.onCheckChange };

    let baseSelect;
    if ( isAdmin( login.code ) ) {
      baseSelect = (
        <Row>
          <Col xs='12'>
            <label>Base</label>
            <BaseSelect value={ this.state.platoon.school_id } 
              onChange={ this.onSelectChange('school_id') } />
          </Col>
        </Row>
      );
    }

    return (
      <Modal isOpen={ isOpen } toggle={ this.toggle } centered id='NewPlatoonModal'>
        <ModalHeader toggle={ this.toggle }>{ isCamp ? 'Create Bunk' : 'Create Platoon' }</ModalHeader>
        <form onSubmit={ this.submit }>
          <ModalBody>
          
          { baseSelect }

          <PlatoonRow
            platoon={ platoon }
            inputProps={ inputProps }
            onSelectChange={ this.onSelectChange }
            checkProps={ checkProps }
            onJSONChange={ this.onJSONChange }
            isCamp={ isCamp }
            />

          { isCamp && (
            <Row className='mt-3'>
              <Col sm={6}>
                <FormGroup>
                  <Label>Counselor 1</Label>
                  <Input value={ counselor1 }
                    onChange={ e => this.setState({ counselor1: e.target.value }) }
                    placeholder='Name' />
                </FormGroup>
              </Col>
              <Col sm={6}>
                <FormGroup>
                  <Label>Counselor 2</Label>
                  <Input value={ counselor2 }
                    onChange={ e => this.setState({ counselor2: e.target.value }) }
                    placeholder='Name (optional)' />
                </FormGroup>
              </Col>
            </Row>
          )}

          { !isCamp && <p className='title'>Platoon Settings</p> }
          { !isCamp && <SettingsRow
            modalOnly
            platoon={ platoon }
            inputProps={ inputProps }
            checkProps={ checkProps }
            onJSONChange={ this.onJSONChange } /> }            

          </ModalBody>

          <ModalFooter>
            <SaveButton show saving={ saving } />
          </ModalFooter>
        </form>
      </Modal>
    );
  }
}

export default NewPlatoonModal;



// WEBPACK FOOTER //
// ./src/pages/base-managment/platoons/newPlatoonModal.jsx